<template lang="pug">
  li.list-option(:class="{checked: checked}")
    label.list-option__label
      .list-option__input
        .radio
          input(
            type="radio"
            :checked="checked"
            name="item-variants"
            @change="$emit('change', id)"
          )
          span
      .list-option__content
        span.list-option__title(v-if="title") {{ title }}
        span.list-option__desc(v-if="desc") {{ desc }}
        Rating.list-option__rating(v-if="rating" :value="rating")

        .list-option__price(v-if="price && !priceDiscount")
          span.list-option__price-normal {{ price }}

        .list-option__price(v-if="price && priceDiscount")
          span.list-option__price-normal
            span.list-option__price-title {{getPriceNormTitle}}:
            | {{ price }}
          span.list-option__price-discount
            span.list-option__price-title {{getPriceDiscTitle}}:
            | {{priceDiscount}}

      .list-option__avatar.avatar.loading(v-if="isShowAvatar" ref="avatar")
        img.avatar__img(:src="avatarChecker(avatarUrl)" :alt="title")
</template>

<script>
import Rating from '../Rating'
import {mapGetters} from 'vuex'
import avatarChecker from '@/mixins/avatar-checker'
import imageOnload from '@/mixins/image-onload'

export default {
  components: {Rating},
  mixins: [avatarChecker, imageOnload],
  props: {
    id: {
      type: Number,
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    inputName: {
      type: String,
      required: true,
    },
    isShowAvatar: {
      type: Boolean,
      required: false,
      default: false,
    },
    avatarUrl: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    desc: {
      type: String,
      required: false,
      default: '',
    },
    rating: {
      type: Number,
      required: false,
      default: null,
    },
    price: {
      type: String,
      required: false,
      default: '',
    },
    priceDiscount: {
      type: String,
      required: false,
      default: '',
    }
  },
  computed: {
    ...mapGetters('config', ['getPriceNormTitle', 'getPriceDiscTitle']),
  },
  mounted() {
    if (this.checked) {
      this.$el.scrollIntoView({behavior: "auto", block: "center"});
    }

    this.imageOnload({
      container: this.$refs?.avatar,
      className: 'loading'
    });
  }
}
</script>
